angular.module('zc.zenclerkS')
  .controller('ZcsSetupCompanyController', ZcsSetupCompanyController);

ZcsSetupCompanyController.$inject = ['$rootScope', '$stateParams', 'Project', 'ZcsOemService', 'project'];
function ZcsSetupCompanyController($rootScope, $stateParams, Project, ZcsOemService, project) {
  const vm = this;
  const pick = [
    'is_same_billing_info',
    'is_direct_selling',
    'companyinfo_confirmed',
    'companyinfo_confirmed_at',
    'company_name',
    'representative',
    'postal_code',
    'address',
    'phone_number',
    'person_in_charge',
    'person_in_charge_email',
    'billing_company_name',
    'billing_representatives',
    'billing_postal_code',
    'billing_address',
    'billing_phone_number',
  ];

  // variables
  vm.project = _.merge({}, _.pick(project, pick));

  if(vm.project.companyinfo_confirmed_at) {
    vm.project.company_check = true;
  }

  vm.isOem = ZcsOemService.isOemService();

  // actions
  vm.save = save;

  activate();

  function activate() {
  }

  function save() {
    vm.project.companyinfo_confirmed = true;
    Project.update({ projectId: `apikey:${$stateParams.apikey}` }, { project: _.pick(vm.project, pick) })
      .then(result => {
        vm.project = _.merge(vm.project, result);
        $rootScope.$broadcast('siteSetup.nextStep');
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/setup/setup_company.controller.js